
import http from '@/http';

const setAuth =  async (context, payload) =>{
 

     try{

        const data = (await http.post("/auth/users", payload)).data
        context.commit("AUTH_USER_SUCCESS", data)


     } catch(err ){
            window.console.log(err)
     }

}

const setState =  async (context) =>{
     context.commit("AUTH_USER_STATE")
}
 

export default {
    setAuth,
    setState, 
     
}